import { forwardRef } from 'react';

import { IconProps } from '.';

export const StarIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 50 50" fill="currentColor" ref={ref} {...props} {...{ className }}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.8701 6.92426C26.7854 4.40563 23.2144 4.40561 22.1297 6.92425L18.3105 15.7928L8.69584 16.6846C5.96531 16.9378 4.86178 20.3341 6.92198 22.1439L14.1763 28.5168L12.0533 37.9364C11.4503 40.6116 14.3394 42.7106 16.6973 41.3105L24.9999 36.3806L33.3025 41.3105C35.6604 42.7106 38.5495 40.6116 37.9465 37.9364L35.8235 28.5168L43.0778 22.1439C45.138 20.3341 44.0345 16.9378 41.304 16.6846L31.6893 15.7928L27.8701 6.92426ZM21.608 17.6169L24.9999 9.74045L28.3919 17.6169C28.8443 18.6675 29.8345 19.3869 30.9734 19.4925L39.5126 20.2845L33.0698 25.9444C32.2104 26.6993 31.8322 27.8634 32.0837 28.9792L33.9692 37.3451L26.5954 32.9667C25.6119 32.3827 24.3879 32.3827 23.4044 32.9667L16.0306 37.3451L17.9161 28.9792C18.1676 27.8634 17.7894 26.6993 16.93 25.9444L10.4873 20.2845L19.0264 19.4925C20.1653 19.3869 21.1555 18.6674 21.608 17.6169Z"
      />
    </svg>
  );
});

export default StarIcon;
